export default "__VITE_ASSET__DnpvDEZi__"